import { User } from "@/types/sorin";
import { useLanguage } from "@/contexts/LanguageContext";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { XPBadge } from "./XPBadge";
import { StreakCounter } from "./StreakCounter";
import { NotificationBell } from "./NotificationBell";
import logoSymbolWhite from "@/assets/logo-symbol-white.svg";

interface SorinHeaderProps {
  user?: User;
  showXP?: boolean;
}

export const SorinHeader = ({ user, showXP = true }: SorinHeaderProps) => {
  const { t } = useLanguage();

  return (
    <header className="sticky top-0 z-50 w-full pt-safe bg-background/80 backdrop-blur-md border-b border-border/50">
      <div className="container flex h-16 items-center justify-between px-4">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-lg bg-gradient-to-br from-primary to-success flex items-center justify-center">
            <img src={logoSymbolWhite} alt="SORIN" className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-base font-semibold tracking-tight text-foreground">SORIN</h1>
            <p className="text-xs text-muted-foreground">{t("header.subtitle")}</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          {user && (
            <>
              <NotificationBell workerId={user.id} />
              {showXP && (
                <div className="flex items-center gap-2">
                  <XPBadge xp={user.xp} size="sm" />
                  <StreakCounter streak={user.streak} size="sm" />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </header>
  );
};
